const getCurrentHostname = (): string => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

export default getCurrentHostname;
